export enum SortDirection {
  Descending = -1,
  Ascending = 1,
}
